import { WorkOrderStatusEnum } from 'gql/graphql';

export const checkIsDisabledByWorkOrderStatus = (
    workOrderStatus: WorkOrderStatusEnum | undefined,
    rowStatus: boolean | undefined | null,
) => {
    if (!workOrderStatus || rowStatus === undefined) {
        return true;
    }

    if (workOrderStatus === WorkOrderStatusEnum.InProgress) {
        if (!rowStatus) {
            return true;
        }
    } else if (workOrderStatus === WorkOrderStatusEnum.OnFormation) {
        if (rowStatus) {
            return true;
        }
    }

    return false;
};
